import { useQuery } from 'react-query';
import { getLateDeliveries } from './api';

export const useLateDeliveriesList = (currentPage) => {
    const { data, isLoading, isError, isSuccess, error } = useQuery(
        ['late-deliveries', currentPage],
        () => getLateDeliveries(currentPage).then((res) => res.data),
    );

    return {
        deliveries: data || [],
        isLoading,
        isError,
        isSuccess,
        error,
    };
};
